module.exports = __webpack_public_path__ + "static/media/pause.65f3dc7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/pause.svg
// module id = 25
// module chunks = 1